import qc from 'qc'
import { addAudioToProject, AudioToProjectParams } from '@ps/api/editor/audio'
import gameIframe from '@ps/bridge/iframe/iframe'
import { removeFileExtension } from '@com/utils/file'

export async function addAudioToPlayable(data: Partial<AudioToProjectParams>) {
  const res = await addAudioToProject(data)
  if (res.code === 0) {
    return res.data
  }
  const e = new Error(res.msg)
  e.name = String(res.code)
  throw e
}

export function addAudioNode({
  parent,
  name,
}: {
  parent: qc.Node
  name: string
}): qc.Node | void {
  if (!gameIframe.ps.AudioNode) {
    console.warn('该版本模板不支持音频')
    return
  }
  // 脚本处理逻辑也要提取过来
  const node = gameIframe.qcGame.add.node(parent)
  node.name = removeFileExtension(name)
  return node
}
